import { gql, useMutation } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import {
  LocalizedEditEntranceTicketTypeInput,
  LocalizedEntranceTicketType,
} from 'apollo/localizedTypes';

const EDIT_ENTRANCE_TICKET_TYPE = gql`
  mutation editEntranceTicketType($input: EditEntranceTicketTypeInput!) {
    editEntranceTicketType(input: $input) {
      adultValue
      description {
        ...LocalizedTextFields
      }
      id
      maxStock
      name {
        ...LocalizedTextFields
      }
      otherValue
      status
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useEditEntranceTicketTypeMutation = () => {
  return useMutation<
    { editEntranceTicketType: LocalizedEntranceTicketType },
    { input: LocalizedEditEntranceTicketTypeInput }
  >(EDIT_ENTRANCE_TICKET_TYPE, {});
};
export default useEditEntranceTicketTypeMutation;
